module.exports = __webpack_public_path__ + "img/model_69_zh.68f54405.png";